module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrapper"
  }, [(_vm.news != null) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.filteredData), function(itemData, keyData) {
    return _c('div', {
      key: keyData,
      staticClass: "one-news"
    }, [_c('p', {
      staticStyle: {
        "font-size": "16px",
        "padding-bottom": "20px"
      }
    }, [_vm._v("Новости")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-family": "'Roboto Thin'",
        "font-size": "16px",
        "padding-bottom": "5px",
        "float": "left"
      }
    }, [_c('b', [_vm._v(_vm._s(itemData.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-size": "11px",
        "padding-bottom": "15px",
        "float": "left"
      }
    }, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(itemData.createdAt)) + "    " + _vm._s(_vm.commonData.users[itemData.author].Name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-size": "13px",
        "clear": "left"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getShortBody(itemData.body))
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "font-size": "13px",
        "padding-top": "15px"
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/news"
      }
    }, [_vm._v("Смотреть другие новости")])], 1)])
  }), _vm._v(" "), (_vm.filteredNews.length == 0) ? _c('div', {
    staticClass: "one-news",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Новости")]), _vm._v("\n      Нет актуальных новостей\n    ")]) : _vm._e()], 2) : _c('div', {
    staticClass: "one-news",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Новости")]), _vm._v("\n    Загружаем новости...\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c8dac2e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsWidget.vue
// module id = 392
// module chunks = 0